import api from '../api';
import { ResponsePagination } from '../models/response-pagination';
import { DownloadFileService } from './download-file.service';
import {
    ExpertArea,
    ExpertCertificate,
    GetExpertCertificates,
    UpdateExpertArea,
    UpdateExpertCertificate,
    UserShort,
} from 'models/expert-certificates';

export class AdminExpertCertificateService {
    static getAreas = () => api.get<ExpertArea[]>(`AdminExpertCertificate/GetAllAreas`);

    static addArea = (request: UpdateExpertArea) => api.post<ExpertArea>('AdminExpertCertificate/AddArea', request);
    static updateArea = (request: UpdateExpertArea) =>
        api.put<ExpertArea>('AdminExpertCertificate/UpdateArea', request);
    static deleteArea = (id: string) => api.delete(`AdminExpertCertificate/DeleteArea?id=${id}`);

    static getCertificates = (request: GetExpertCertificates) =>
        api.get<ResponsePagination<ExpertCertificate>>(`AdminExpertCertificate/GetCertificates`, {
            params: request,
        });
    static getCertificatesXls = (request: GetExpertCertificates) =>
        DownloadFileService.download('AdminExpertCertificate/GetCertificatesExcel', request);

    static addCertificate = (request: UpdateExpertCertificate) =>
        api.post<ExpertCertificate>('AdminExpertCertificate/AddCertificate', {
            ...request,
            countOfMount: request.countOfMount ? parseInt(`${request.countOfMount}`) : null,
        });
    static updateCertificate = (request: UpdateExpertCertificate) =>
        api.put<ExpertCertificate>('AdminExpertCertificate/UpdateCertificate', {
            ...request,
            countOfMount: request.countOfMount ? parseInt(`${request.countOfMount}`) : null,
        });
    static deleteCertificate = (id: string) => api.delete(`AdminExpertCertificate/DeleteCertificate?id=${id}`);

    static getUsers = (email?: string | null) => {
        const address = email ? `AdminExpertCertificate/GetUsers?email=${email}` : `AdminExpertCertificate/GetUsers`;
        return api.get<UserShort[]>(address);
    };
}
